import { AccountCalendarModel } from "./../../../models/account-calendar.model";
import { RegionsEnum, TemplateEnum } from "./../../../enums/regions.enum";
import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { EngagementModel } from "../../../models/engagement.model";
import { MessageService } from "primeng/api";
import { EngagementService } from "./../../../services/engagement.service";
import { CurrencyService } from "./../../../services/currency.service";
import { MonthService } from "./../../../services/month.service";
import { UserService } from "./../../../services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CurrencyModel } from "../../../models/currency.model";
import { MonthModel } from "../../../models/month.model";
import { UserModel } from "../../../models/user.model";
import { RegionService } from "../../../services/region.service";
import { RegionModel } from "../../../models/region.model";
import {
  severitymessage,
  FunctionalityNames,
  LanguageConstants,
} from "../../../shared-components/constant";
import { AuditingService } from "../../../services/auditing.service";
import { PbiWorkSpaceService } from "src/app/services/pbiworkspace.service";
import { InfraService } from "src/app/services/infra.service";
import { CountryService } from "src/app/services/country.service";
import { AccountingCalendarEnum } from "../../../enums/accounting-calendar.enum";
import { AccountingCalendarService } from "../../../services/accounting-calendar.service";
import moment from "moment";
import { MasterLanguage } from "../../../models/MasterLanguage.model";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { LanguageHelperService } from "src/app/services/language.helper.service";
import { ProjectCategoryService } from "../../../services/project-category.service";
import { ProjectCategoryModel } from "../../../models/project-category.model";
import { DatabookLanguage } from "../../../enums/databook-language.enum";
import { PbiWorkSpaceModel } from "../../../models/pbiWorkSpace.model";
import { environment } from "../../../../environments/environment";
@Component({
  standalone: false,
  selector: "app-add-edit",
  templateUrl: "./add-edit.component.html",
  styleUrls: ["./add-edit.component.css"],
})
export class AddEditEngagementComponent implements OnInit {
  private EnvName = environment.ENV;
  public saveClicked = false;
  public updateClicked = false;
  public isEditEngagement = false;
  public isFiscalMonthEditable = false;
  public isTemplateEditable = false;
  public engagement: EngagementModel = new EngagementModel();
  public pbiWorkSpace: PbiWorkSpaceModel = new PbiWorkSpaceModel();
  //public pbiWorkSpaceUser: PbiWorkSpaceUserModel = new PbiWorkSpaceUserModel();
  public existingAddedUsers: UserModel[];
  accountCalendar53rdweekYearList = [];
  p445FiscalYear: any;
  fisicalYearDate: any;
  fiftyThirdweekValue = false;
  fiscalErrormsgShow = false;
  @ViewChild("formaddengagement", { static: true }) form: any;
  public currencies: CurrencyModel[];
  public regions: RegionModel[];
  public templateList: RegionModel[];
  filterTemplateList: RegionModel[];
  public countryList: RegionModel[];
  public accountingCalendarList = [];
  filterAccountingCalendarList = [];
  public firstInstanceOf_5th_Week_YearList: number[] = [];
  public months: MonthModel[] = [];
  public results: UserModel[] = [];
  private id = +this.route.snapshot.paramMap.get("id");
  private loggedInUserData: UserModel[];
  private regionName = "";
  public selectedRegionId = null;
  public selectedCountryId = null;
  public selectedTemplateId = null;
  public disableCountry = false;
  public fiscalEndMonthButtonDisable = true;
  public isFirstDateOfFiscalYearHide = false;
  public dateFormater: string;
  public isFirstDateOfFifthYearValid = true;
  public calendarName: number;
  public fiftyThirtyWeekYearValidation = true;
  public isFiscalYearEnabled = false;
  public startDateOfFisicalYear = null;
  public placeHolderDateFormater: string;
  public minDate: Date = new Date(new Date().getFullYear() - 5, 0, 1);
  public maxDate: Date = new Date(new Date().getFullYear(), 11, 31);
  public languages: MasterLanguage[] = [];
  disableLanguage: boolean = false;
  langCode: string;
  currLangTranslation: any;
  public projectCategories: ProjectCategoryModel[];
  //disablePaceId = false;
  disableProjectCategory = false;
  disableAccountingCalendar = false;
  public engEnvironment: string = null;
  public isEngagementAvailable: number = 0;
  public isEngagementChangeValid: boolean = false;
  private pbiRegion: any;
  private existingUserData: UserModel[];
  private newUserData: UserModel[];
  private differenceUserData: UserModel[];
  userEmail: string = "";
  addRemove: string = "";
  isRequired:boolean = false;
  isClearClicked: boolean = false;
  accCalenderId : string = 'P12';
  isAccCalenderIdDisabled : boolean = true;
  accCalenderIds = [
    { value : 'P12', Id : 1},
    { value : 'P13', Id : 2},
    { value : '445', Id : 3},
    { value : '454', Id : 4},
    { value : '544', Id : 5}];
  constructor(
    private infraService: InfraService,
    private userService: UserService,
    private messageService: MessageService,
    private engagementService: EngagementService,
    private router: Router,
    private currencyService: CurrencyService,
    private monthService: MonthService,
    private countryService: CountryService,
    private route: ActivatedRoute,
    private regionService: RegionService,
    private auditingService: AuditingService,
    private accountingCalendarService: AccountingCalendarService,
    private translateService: TranslateService,
    private pbiworkspaceService: PbiWorkSpaceService,
    private languageHelper: LanguageHelperService,
    private projectCategoryService: ProjectCategoryService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.infraService.infraDetails$.subscribe((data) => {
      if (data !== undefined) {
        this.selectedRegionId = data.InfraId;
        this.selectedCountryId = data.CountryId;
        this.selectedTemplateId = data.TemplateId;
        this.regionName = data.RegionName;
        if (this.selectedRegionId !== RegionsEnum.US) {
          this.dateFormater = "dd/mm/yy";
          this.placeHolderDateFormater = "dd/mm/yyyy";
        } else {
          this.dateFormater = "mm/dd/yy";
          this.placeHolderDateFormater = "mm/dd/yyyy";
        }
      }
    });

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined && Object.keys(userData).length !== 0) {
        this.loggedInUserData = [];
        this.loggedInUserData.push(userData);
      }
      if (this.loggedInUserData && this.loggedInUserData.length > 0) {
        const event = {
          query: this.loggedInUserData[0].FamilyName,
        };
        this.searchUsers(event);
      }
    });
  }
  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.messageService.clear("myKey1");
    this.getTemplates(this.selectedRegionId);
    this.getCurrencies();
    this.getAccountingCalendar();
    this.getProjectCategories();
    this.populateFirstInstanceOf5thWeekYear();
    this.populate53rdWeekYear();
    console.log('oninitEnv:', environment.ENV)
    this.setWorkSpaceModel();
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.langCode = langEvent.lang;
      this.getFiscalYearMonth();
      this.getProjectCategories();
      //this.getPlaceHolder();
    });
  }
  private intializeEngagementModel() {
    this.engagement = {
      Id: 0,
      EngagementName: "",
      PaceId: "",
      ReportingCurrencyId: null,
      Status: true,
      FiscalYearMonth: 12, // setting fiscal month to December
      RegionId: this.selectedRegionId,
      RegionName: this.regionName,
      CountryId: this.selectedCountryId,
      TemplateId: this.selectedTemplateId,
      UserNames: [],
      CreatedBy: this.loggedInUserData[0].Id,
      IsLocalCopyUploaded: false,
      Type: "",
      isEditable: false,
      DatabookVersion: null,
      MappingLevel: null,
      AccCalendarId: 1,
      LanguageId: 2,
      FirstInstanceOfFifthWeekYear: null,
      FirstDateOfFiscalYear: null,
      isPLAcccounts: null,
      IsAccountMappingDone: 0,
      FiftythirdWeekYear: null,
      IsDynamicDatabook: false,
      ProjectCategoryId: null,
      IsTestProjectWorkspaceEnabled: null,
      IsEngagementAvailable: false,
    };
  }

  private setWorkSpaceModel() {
    console.log("setworkspacemodelenv", environment.ENV);
    console.log("setworkspacemodelenv", this.EnvName.toLowerCase());
    if (
      this.EnvName.toLowerCase() === "dev" ||
      this.EnvName.toLowerCase() === "local" ||
      this.EnvName.toLowerCase() === "azureeverest"
    ) {
      this.EnvName = "Development";
    } else if (this.EnvName.toLowerCase() === "qa") {
      this.EnvName = "QA";
    } else if (this.EnvName.toLowerCase() === "prod") {
      this.EnvName = "Production";
    } else if (this.EnvName.toLowerCase() === "uat") {
      this.EnvName = "UAT";
    }
    if (this.regionName.toUpperCase() === "US") {
      this.pbiRegion = "eastus";
    } else if (this.regionName.toUpperCase() === "EMEIA") {
      this.pbiRegion = "westeurope";
    } else if (this.regionName.toUpperCase() === "APAC") {
      this.pbiRegion = "australiaeast";
    }

    this.pbiWorkSpace = {
      environment: this.EnvName,
      location: this.pbiRegion,
      pbiworkspace: true,
      pbiworkspacedestroy: false,
      pbiworkspaceName: "Workspace_Engagement_" + this.engagement.Id,
      userEmails: this.userEmail,
      Access: "Contributor",
      addremove: this.addRemove,
      workspaceName: "Workspace_Engagement_" + this.engagement.Id,
      requestedby: this.loggedInUserData[0].UPN,
    };
  }

  private getCurrencies(): void {
    this.currencyService.getAllCurrencies().subscribe((data: any) => {
      this.currencies = data;
      this.getCountries();
      this.engagementService
        .GetAllActiveLanguages()
        .subscribe((data: MasterLanguage[]) => {
          if (this.selectedRegionId == RegionsEnum.APAC) {
            this.languages = data;
          } else {
            this.languages = data.filter(
              (x) => x.Id !== DatabookLanguage.Japanese
            );
          }
          this.engagement.LanguageId = null;
          this.changeDetectorRef.markForCheck();
          if (this.id > 0) {
            this.isEditEngagement = true;
            this.getEngagementForEdit();
          } else {
            this.disableCountry = true;
            this.isFiscalMonthEditable = true;
            this.isTemplateEditable = true;
            this.intializeEngagementModel();
            //this.form.controls['engusers'].markAsTouched();
            this.getFiscalYearMonth();
            this.setFirstDateOfFiscalYearVisibilityStatus(
              this.engagement.AccCalendarId
            );
            this.onRegionChange(this.selectedRegionId);
          }
        });
    });
  }

  private getCountries(): void {
    this.regionService
      .getCountriesByRegion(this.regionName)
      .subscribe((data: RegionModel[]) => {
        this.countryList = data;
        this.changeDetectorRef.markForCheck();
      });
  }

  private getTemplates(regionId: number): void {
    this.regionService
      .getTemplates(regionId)
      .subscribe((data: RegionModel[]) => {
        this.templateList = data;
        this.filterTemplateList = data;
        this.changeDetectorRef.markForCheck();
      });
  }

  // private getRegions(): void {
  //  this.regionService.getRegions().subscribe((data: RegionModel[]) => {
  //    this.regions = data.filter(w => w.Id == +this.selectedregion);
  //    const dd = this.regions.find(r => r.Id === +this.selectedregion);
  //    this.engagement.RegionId = dd.Id;
  //    this.engagement.RegionName = dd.Name;
  //    this.onRegionChange(this.selectedregion);
  //  });
  // }

  private getAccountingCalendar(): void {
    this.accountingCalendarService
      .getAccountingCalendar()
      .subscribe((data: AccountCalendarModel[]) => {
        this.accountingCalendarList = data;
        this.filterAccountingCalendarList = data;
        this.changeDetectorRef.markForCheck();
      });
  }

  private getProjectCategories(): void {
    this.projectCategoryService.GetProjectCategories().subscribe((data) => {
      this.projectCategories = data;
      this.projectCategories.forEach((element: any) => {
        element.category =
          this.currLangTranslation.projectManagement[element.category];
      });
      this.changeDetectorRef.markForCheck();
    });
  }

  private populateFirstInstanceOf5thWeekYear(): void {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear() + 5;
    const previousYear = currentDate.getFullYear() - 5;
    for (let i = previousYear; i <= currentYear; i++) {
      this.firstInstanceOf_5th_Week_YearList.push(i);
    }
  }

  populate53rdWeekYear(): void {
    const currentDate = new Date();
    if (this.engagement.FiftythirdWeekYear !== null) {
      this.engagement.FiftythirdWeekYear = this.engagement.FiftythirdWeekYear;
    } else {
      this.engagement.FiftythirdWeekYear = null;
    }
    const currentYear = currentDate.getFullYear() + 5; // 20+5 = 25
    const previousYear = currentDate.getFullYear() - 5; // 20-5
    for (let i = previousYear; i <= currentYear; i++) {
      this.accountCalendar53rdweekYearList.push(i);
    }
  }
  populalteFiscialYearEnd() {
    if (
      (this.engagement.AccCalendarId === AccountingCalendarEnum.P445 ||
        this.engagement.AccCalendarId === AccountingCalendarEnum.P454 ||
        this.engagement.AccCalendarId === AccountingCalendarEnum.P544) &&
      this.engagement.FirstDateOfFiscalYear !== null &&
      this.engagement.FiftythirdWeekYear !== null
    ) {
      this.calculateFisicalYearEnd();
    }
  }

  /* Start logic for Fiscal Year End month */
  calculateFisicalYearEnd() {
    const fiftyThirdWeekYear: number = this.engagement.FiftythirdWeekYear;
    const startDateofFisicalYear: number =
      this.engagement.FirstDateOfFiscalYear.getFullYear();
    const resultDate: any = this.engagement.FirstDateOfFiscalYear;
    const fisicalYearDate = new Date(this.engagement.FirstDateOfFiscalYear);
    let finalMonth: number;
    fisicalYearDate.setDate(resultDate.getDate() + 363); // add 360 days when years are not equal
    this.engagement.FirstDateOfFiscalYear = resultDate;
    finalMonth = fisicalYearDate.getMonth() + 1;
    this.filterFiscalYearEndMonth(finalMonth);
  }
  /* End logic for Fiscal Year End month */

  filterFiscalYearEndMonth(finalMonth) {
    if (this.months.length) {
      this.months.filter((values) => {
        if (finalMonth === values.Id) {
          this.engagement.FiscalYearMonth = values.Id;
        }
      });
    }
  }

  onFiscalEndChange(val) {
    if (val.control && val.control.errors && val.control.errors.required) {
      this.fiscalErrormsgShow = true;
    } else {
      this.fiscalErrormsgShow = false;
    }
  }

  onFiftyThirdWeekYearChange(value, data?: any) {
    if (value !== null) {
      this.engagement.FiftythirdWeekYear = value;
      const fiftyThirdYear: number = value;
      if (this.engagement.FirstDateOfFiscalYear !== null) {
        const fiscalYear: number =
          this.engagement.FirstDateOfFiscalYear.getFullYear();
        this.isFirstDateOfFifthYearValid = fiftyThirdYear >= fiscalYear;
        if (this.fiftyThirtyWeekYearValidation) {
          this.populalteFiscialYearEnd();
        }
      }
    } else {
      this.isFirstDateOfFifthYearValid = true;
      if (data.control && data.control.errors && data.control.errors.required) {
        this.fiftyThirdweekValue = true;
      }
    }
  }

  private getFiscalYearMonth(): void {
    this.monthService.getAllMonths().subscribe(
      (response: MonthModel[]) => {
        this.months = response;
        this.months.forEach((element) => {
          element.Month = this.languageHelper.convertMonthToLocale(
            this.langCode,
            element.Month
          );
        });
        this.changeDetectorRef.markForCheck();
        // if(!this.isEditEngagement) {
        //  this.getRegions();
        // }
      },
      (error) => { }
    );
  }

  onRegionChange(selectedregion) {
    if (this.selectedRegionId === 1) {
      const cc = this.currencies.find((r) => r.Code === "USD");
      this.engagement.ReportingCurrencyId = cc.Id;
    }
  }

  onCountryChange(selectedCountryId: number) {
    if (this.engagement.DaiseyProjectId != null) {
      this.countryService.getcountrylist().subscribe((data: any[]) => {
        this.engagement.TemplateId = data.find(
          (x) => x.Id === selectedCountryId
        )["TemplateId"];
        localStorage.setItem(
          "selectedInfra",
          `${selectedCountryId}, ${this.engagement.TemplateId}, ${this.selectedRegionId}`
        );
        this.onRegionChange(this.selectedRegionId);
      });
    }
  }

  onProjectCategoryChange(id: number) {
    //this.disablePaceId = false;
    switch (id) {
      case 1:
        this.engagement.IsEngagementAvailable = false;
        this.engagement.PaceId = "";
        break;
      case 2:
        this.engagement.IsTestProjectWorkspaceEnabled = null;
        this.engagement.PaceId = "Test";
        break;
      case 3:
        //this.engagement.IsTestProjectWorkspaceEnabled = null;
        this.engagement.PaceId = "Training";
        break;
    }
    // if (id === 1) { //client engagement
    //   this.engagement.IsTestProjectWorkspaceEnabled = null;
    // } else if (id === 2) { //test project

    //   //this.disablePaceId = true;
    // }
  }

  onAccountCalendarChange(selectedAccountingCalendar: number): void {
    // this.hideTotalCostTemplate(selectedAccountingCalendar);
    this.setFirstDateOfFiscalYearVisibilityStatus(selectedAccountingCalendar);
  }

  // when we select 445,454 & 544 calendars hiding, total cost template from Template dropdown
  // hideTotalCostTemplate(calendarValue: any) {
  //   if (calendarValue && calendarValue !== null) {
  //     if (calendarValue === AccountingCalendarEnum.P445 || calendarValue === AccountingCalendarEnum.P454
  //       || calendarValue === AccountingCalendarEnum.P544) {
  //         if(this.templateList !== null && this.templateList !== undefined && this.templateList.length>0) {
  //           this.templateList = this.templateList.filter((val) => val.Id !== TemplateEnum.TotalCost);
  //         }
  //     } else {
  //       this.templateList = this.filterTemplateList;
  //     }
  //   } else {
  //     this.templateList = this.filterTemplateList;
  //   }
  // }
  setFirstDateOfFiscalYearVisibilityStatus(
    selectedAccountingCalendar: number
  ): void {
    if (
      selectedAccountingCalendar == AccountingCalendarEnum.P12 &&
      selectedAccountingCalendar !== null &&
      selectedAccountingCalendar !== undefined &&
      this.engagement.AccCalendarId !== 0
    ) {
      this.calendarName = selectedAccountingCalendar;
      this.fiscalEndMonthButtonDisable = true;
      this.engagement.FirstInstanceOfFifthWeekYear = null;
      this.engagement.FirstDateOfFiscalYear = null;
      this.isFirstDateOfFiscalYearHide = false;
      this.isFirstDateOfFifthYearValid = true;
      this.engagement.FiscalYearMonth = 12;
    } else if (
      selectedAccountingCalendar === AccountingCalendarEnum.P13 &&
      selectedAccountingCalendar !== null &&
      selectedAccountingCalendar !== undefined &&
      this.engagement.AccCalendarId !== 0
    ) {
      this.calendarName = selectedAccountingCalendar;
      this.fiscalEndMonthButtonDisable = false;
      this.engagement.FirstInstanceOfFifthWeekYear = null;
      this.engagement.FirstDateOfFiscalYear = null;
      this.isFirstDateOfFiscalYearHide = true;
      this.isFirstDateOfFifthYearValid = true;
      this.engagement.FiscalYearMonth = null;
    } else if (
      (selectedAccountingCalendar == AccountingCalendarEnum.P445 ||
        selectedAccountingCalendar == AccountingCalendarEnum.P454 ||
        selectedAccountingCalendar == AccountingCalendarEnum.P544) &&
      selectedAccountingCalendar !== null &&
      selectedAccountingCalendar !== undefined &&
      this.engagement.AccCalendarId !== 0
    ) {
      this.fiscalEndMonthButtonDisable = false;
      this.calendarName = selectedAccountingCalendar;
      this.isFirstDateOfFiscalYearHide = true;
      this.isFirstDateOfFifthYearValid = true;
      if (this.fiftyThirdweekValue) {
        this.fiftyThirdweekValue = false;
      }
      if (this.fiscalErrormsgShow) {
        this.fiscalErrormsgShow = false;
      }

      if (
        !this.isEditEngagement ||
        this.isEditEngagement ||
        this.engagement.AccountCalendar === "P12" ||
        this.engagement.AccountCalendar === "P13"
      ) {
        this.engagement.FirstDateOfFiscalYear = null;
        this.engagement.FiscalYearMonth = null;
        this.engagement.FiftythirdWeekYear = null;
        this.fisicalYearDate = null;
        this.p445FiscalYear = null;
      }

      if (this.fisicalYearDate && this.fisicalYearDate !== null) {
        this.engagement.FirstDateOfFiscalYear = new Date(this.fisicalYearDate);
      }

      if (this.p445FiscalYear && this.p445FiscalYear.FiscalYearMonth !== 0) {
        this.months.filter((values) => {
          if (this.p445FiscalYear.FiscalYearMonthName === values.Month) {
            this.engagement.FiscalYearMonth = values.Id;
          }
        });
      } else {
        this.engagement.FiscalYearMonth = null;
      }
      this.fiftyThirtyWeekYearValidation = true;
    } else {
      this.isFirstDateOfFiscalYearHide = false;
      this.engagement.FiscalYearMonth = 12;
      this.fiscalEndMonthButtonDisable = true;
    }
  }
  // To get project team members in engagement edit page
  getProjectTeam() {
    this.engagementService
      .getEngagementUsers(this.id)
      .subscribe((userData: UserModel[]) => {

        userData = userData.filter((obj,index,item)=> index === item.findIndex(x=>x.Id === obj.Id));
        this.engagement.UserNames = userData;
        this.existingAddedUsers = userData;
        this.existingUserData = userData;
        this.getFiscalYearMonth();
        for (let i = 0; i < userData.length; i++) {
          if (i === 0) this.userEmail = userData[i].UPN;
          else this.userEmail = this.userEmail + "," + userData[i].UPN;
        }
      });
  }

  private getEngagementForEdit() {
    this.engagementService.getEngagement(this.id).subscribe(
      (data: EngagementModel) => {
        this.engagement = data;
        this.getProjectTeam();
        // this.templateOptionChange(data.TemplateId);
        // this.hideTotalCostTemplate(data.AccountCalendarId);
        this.fisicalYearDate = data.FirstDateOfFiscalYear;
        this.p445FiscalYear = data;
        if (this.engagement.ReportingCurrencyId == 0) {
          this.engagement.ReportingCurrencyId = null;
        }
        if (this.engagement.AccCalendarId == 0) {
          this.engagement.AccCalendarId = null;
        }
        if (this.engagement.FiscalYearMonth == 0) {
          this.engagement.FiscalYearMonth = null;
        }
        if (
          this.engagement.AccCalendarId !== AccountingCalendarEnum.P12 &&
          this.engagement.AccCalendarId !== null &&
          this.engagement.AccCalendarId !== undefined &&
          this.engagement.AccCalendarId !== 0
        ) {
          this.isFirstDateOfFiscalYearHide = true;
        } else {
          this.isFirstDateOfFiscalYearHide = false;
        }
        this.engagement.FirstDateOfFiscalYear = moment(
          data.FirstDateOfFiscalYear
        ).toDate();
        if (
          this.engagement.DaiseyProjectId == null ||
          this.engagement.CountryId > 0
        ) {
          if (this.engagement.WBStatus || this.engagement.WBStatus == null)
            this.disableCountry = true;
        }

        if (
          this.engagement.AccCalendarId === AccountingCalendarEnum.P13 &&
          this.engagement.AccCalendarId !== null &&
          this.engagement.AccCalendarId !== undefined 
         // this.engagement.AccountCalendarId !== 0
        ) {
          this.fiscalEndMonthButtonDisable = false;
          this.showFiscalDateOfFifthYearValidation();
        } else if (
          (this.engagement.AccCalendarId === AccountingCalendarEnum.P445 ||
            this.engagement.AccCalendarId === AccountingCalendarEnum.P454 ||
            this.engagement.AccCalendarId ===
            AccountingCalendarEnum.P544) &&
          this.engagement.AccCalendarId !== null &&
          this.engagement.AccCalendarId !== undefined 
          //this.engagement.AccountCalendarId !== 0
        ) {
          this.fiscalEndMonthButtonDisable = false;
          this.onFirstDateOfFiscalYearChange(data.FirstDateOfFiscalYear);
        } else {
          this.isFirstDateOfFifthYearValid = true;
        }
        if (!this.engagement.WBStatus)
          this.isTemplateEditable = true;

        this.engagement.RegionName = this.regionName;
        this.engagement.RegionId = this.selectedRegionId;
        if (this.engagement.FiscalYearMonth === null) {
          this.isTemplateEditable = true;
          this.isFiscalMonthEditable = true;
          if (
            this.engagement.AccCalendarId !== 0 &&
            this.engagement.AccCalendarId !== 1
          ) {
            this.fiscalEndMonthButtonDisable = false;
          } else {
            if (this.engagement.WBStatus || this.engagement.WBStatus == null)
              this.fiscalEndMonthButtonDisable = true;
          }
        } else {
          if (this.engagement.WBStatus || this.engagement.WBStatus == null)
            this.isTemplateEditable = false;
          if (
            this.engagement.FiscalYearMonth !== null &&
            this.engagement.IsAccountMappingDone !== undefined &&
            this.engagement.IsAccountMappingDone !== null &&
            this.engagement.IsAccountMappingDone > 0
          ) {
            this.isFiscalMonthEditable = false;
            this.fiscalEndMonthButtonDisable = false;
          } else {
            this.isFiscalMonthEditable = true;
            if (this.engagement.AccCalendarId !== 1) {
              this.fiscalEndMonthButtonDisable = false;
            } else {
              this.fiscalEndMonthButtonDisable = true;
            }
          }
        }
        if (this.engagement.LanguageId === DatabookLanguage.Japanese) {
          this.disableAccountingCalendar = true;
        }
        if (this.engagement.WBStatus || this.engagement.WBStatus == null) {
          this.disableLanguage = true;
          this.disableProjectCategory = true;
        }
        this.engagement.IsEngagementAvailable = data.IsEngagementAvailable;
        this.isEngagementAvailable =
          data.IsEngagementAvailable === true ? 1 : 0;

        this.accCalenderId = this.accCalenderIds.filter(x=>x.Id === this.engagement.AccCalendarId)[0].value;

        console.log('accCalId',this.accCalenderId);
      },
      (error) => {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: error.error.message,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  searchUsers(event) {
    this.userService.getADUsers(event.query).subscribe(
      (data: UserModel[]) => {
        this.results = data;
      },
      (error) => { }
    );
  }

  saveEngagement() {
    if (this.form.valid) {
      this.saveClicked = true;
      this.engagement.StartDateOfSourceData = moment(
        this.engagement.FirstDateOfFiscalYear
      ).format("YYYY-MM-DD");
      if (this.engagement.UserNames?.length === 0){
        this.engagement.UserNames = this.loggedInUserData;
      }
      this.engagementService.save(this.engagement).subscribe(
        (response: any) => {
          if (response.message === severitymessage.success) {
            this.saveClicked = true;
            this.engagement.Id = response.engagementId;
            this.auditingService
              .addAudit(
                response.engagementId,
                FunctionalityNames.EngagementCreation
              )
              .subscribe();
            if (
              this.engagement.ProjectCategoryId === 3 &&
              this.engagement.IsTestProjectWorkspaceEnabled == true
            ) {
              this.auditingService
                .addAudit(
                  response.engagementId,
                  FunctionalityNames.TrainingWorkspaceCreated
                )
                .subscribe();
            }
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key2,
              severity: severitymessage.success,
              summary: this.currLangTranslation.severitymessage.notification,
              detail:
                this.currLangTranslation.engagementDetailMessage.SuccessMessage
                  .Created,
              life: 10000,
            });
            this.addRemove = "add";
            this.newUserData = this.engagement.UserNames;
            for (let i = 0; i < this.engagement.UserNames.length; i++) {
              if (i === 0) this.userEmail = this.engagement.UserNames[i].UPN;
              else
                this.userEmail =
                  this.userEmail + "," + this.engagement.UserNames[i].UPN;
            }
            //Commenting the triggerint point of PBI 
            this.setWorkSpaceModel();
            // if (this.engagement.IsTestProjectWorkspaceEnabled === true || this.engagement.ProjectCategoryId === 1)
            // {
            //   console.log("pbiWorkSpace :", this.pbiWorkSpace);
            //   this.pbiworkspaceService.createWorkSpaceQueue(this.pbiWorkSpace);
            //   setTimeout(() => {
            //     this.pbiworkspaceService.addUser(this.pbiWorkSpace);
            //   }, 180000);
            // }
            this.router.navigate(["engagement"]);
          } else {
            this.saveClicked = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (error) => {
          this.saveClicked = false;
          if (error.error.message == 'Invalid Model Data') {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.mandatoryFieldsError,
              sticky: true,
              closable: true,
            });
          }
          else {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: error.error.message,
              sticky: true,
              closable: true,
            });
          }
        }
      );
    }
  }

  updateEngagement() {
    if (this.form.dirty === true) {
      if (this.form.valid) {
        this.updateClicked = true;
        this.engagement.ModifiedBy = this.loggedInUserData[0].Id;
        if (
          this.engagement.AccCalendarId === AccountingCalendarEnum.P12 ||
          this.engagement.AccCalendarId === null ||
          this.engagement.AccCalendarId === undefined ||
          this.engagement.AccCalendarId === 0
        ) {
          this.engagement.FirstDateOfFiscalYear = null;
        } else {
          this.engagement.StartDateOfSourceData = moment(
            this.engagement.FirstDateOfFiscalYear
          ).format("YYYY-MM-DD");
        }
        this.newUserData = this.engagement.UserNames;

        for (let i = 0; i < this.existingUserData.length; i++) {
          if (i === 0) this.userEmail = this.existingUserData[i].UPN;
          else
            this.userEmail =
              this.userEmail + "," + this.existingUserData[i].UPN;
        }
        if (this.newUserData === this.existingUserData) {
        }
        else {
          this.addRemove = "remove";

          // Commenting the triggerint point of PBI
          if (this.engagement.IsTestProjectWorkspaceEnabled === true || this.engagement.ProjectCategoryId === 1) {
            this.setWorkSpaceModel();
            this.pbiworkspaceService
              .deleteUser(this.pbiWorkSpace)
              .subscribe((response: any) => { });

            for (let i = 0; i < this.engagement.UserNames.length; i++) {
              if (i === 0) this.userEmail = this.engagement.UserNames[i].UPN;
              else
                this.userEmail =
                  this.userEmail + "," + this.engagement.UserNames[i].UPN;
            }
            this.addRemove = "add";
            this.setWorkSpaceModel();
            setTimeout(() => {
              this.pbiworkspaceService.addUser(this.pbiWorkSpace);
            }, 540000);
          }
        }
        this.engagementService.update(this.engagement).subscribe(
          (response: any) => {
            if (response.message === severitymessage.success) {
              this.updateClicked = true;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key2,
                severity: severitymessage.success,
                summary: this.currLangTranslation.severitymessage.notification,
                detail:
                  this.currLangTranslation.engagementDetailMessage
                    .SuccessMessage.Updated,
                life: 10000,
              });
              if (localStorage.getItem("dProjectId")) {
                this.infraService.setInfraDetails(
                  localStorage.getItem("selectedInfra")
                );
                this.router.navigate(["/viewengagement", this.id]);
              } else {
                this.router.navigate(["engagement"]);
              }
            } else {
              this.updateClicked = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          },
          (error) => {
            this.updateClicked = false;

            if (error.error.message == 'Invalid Model Data') {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.mandatoryFieldsError,
                sticky: true,
                closable: true,
              });
            }
            else {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: error.error.message,
                sticky: true,
                closable: true,
              });
            }
          }
        );
      }
    } else {
      this.updateClicked = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.severitymessage.NoChange,
        sticky: true,
        closable: true,
      });
    }
  }

  showFiscalDateOfFifthYearValidation() {
    if (
      this.engagement.AccCalendarId !== AccountingCalendarEnum.P12 &&
      this.engagement.AccCalendarId !== null &&
      this.engagement.AccCalendarId !== undefined &&
      this.engagement.AccCalendarId !== 0
    ) {
      // tslint:disable-next-line:radix
      const fifthWeekYear: Number =
        this.engagement.FirstInstanceOfFifthWeekYear;
      this.startDateOfFisicalYear = this.engagement.FirstDateOfFiscalYear;
      const fiscalYear: Number =
        this.engagement.FirstDateOfFiscalYear.getFullYear();
      this.isFirstDateOfFifthYearValid = fifthWeekYear >= fiscalYear;
    } else {
      this.isFirstDateOfFifthYearValid = true;
    }
  }
  onFirstDateOfFifthYearChange() {
    this.showFiscalDateOfFifthYearValidation();
    if (
      this.engagement.FirstInstanceOfFifthWeekYear &&
      this.engagement.FirstDateOfFiscalYear &&
      this.engagement.AccCalendarId === AccountingCalendarEnum.P13
    ) {
      this.calculateEndMonthForP13();
    }
  }

  onFirstDateOfFiscalYearChange(value) {
    this.engagement.FirstDateOfFiscalYear = value;
    if (this.engagement.AccountCalendar === "P13") {
      this.showFiscalDateOfFifthYearValidation();
    } else {
      this.isFirstDateOfFifthYearValid = true;
    }
    if (
      this.engagement.FiftythirdWeekYear !== null &&
      this.engagement.FiftythirdWeekYear !== 0 &&
      (this.engagement.AccCalendarId === AccountingCalendarEnum.P445 ||
        this.engagement.AccCalendarId === AccountingCalendarEnum.P454 ||
        this.engagement.AccCalendarId === AccountingCalendarEnum.P544)
    ) {
      this.onFiftyThirdWeekYearChange(this.engagement.FiftythirdWeekYear);
    } else if (
      this.engagement.FirstInstanceOfFifthWeekYear &&
      this.engagement.FirstDateOfFiscalYear &&
      this.engagement.AccCalendarId === AccountingCalendarEnum.P13
    ) {
      this.calculateEndMonthForP13();
    } else {
      this.isFirstDateOfFifthYearValid = true;
    }
  }

  cancel() {
    this.messageService.clear();
    if (localStorage.getItem("dProjectId")) {
      this.router.navigate(["/viewengagement", this.id]);
    } else {
      this.router.navigate(["engagement"]);
    }
  }

  private calculateEndMonthForP13() {
    if (!this.isFirstDateOfFifthYearValid) {
      this.engagement.FiscalYearMonth = null;
      return false;
    }
    const resultDate: any = this.engagement.FirstDateOfFiscalYear;
    const startDateofFisicalYear: number =
      this.engagement.FirstDateOfFiscalYear.getFullYear();
    const fisicalYearDate = new Date(this.engagement.FirstDateOfFiscalYear);
    let finalMonth: number;
    fisicalYearDate.setDate(resultDate.getDate() + 363); // add  363 days
    finalMonth = fisicalYearDate.getMonth() + 1;
    this.filterFiscalYearEndMonth(finalMonth);
  }

  onProjectNameChange() {
    const pattern = /[@*"\`\\()/';:=\[\]]/;
    if (pattern.test(this.engagement.EngagementName)) {
      this.form.controls["engagementName"].setErrors({ pattern: true });
      return;
    } else {
      this.form.get["engagementName"].setErrors({ pattern: false });
      return;
    }
  }

  onPaceIdChange() {
    const pattern = /[@*"\`\\()/';:=\[\]]/;
    if (pattern.test(this.engagement.PaceId)) {
      this.form.controls["PaceId"].setErrors({ pattern: true });

      return;
    } else {
      this.form.get["PaceId"].setErrors({ pattern: false });
      return;
    }
  }

  onLanguageChange(langId: number) {
    if (langId === DatabookLanguage.Japanese) {
      if (this.engagement.AccCalendarId != AccountingCalendarEnum.P12) {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.severitymessage
              .OnlyP12SupportedForJapanese,
          sticky: true,
          closable: true,
        });
      }
      this.engagement.AccCalendarId = AccountingCalendarEnum.P12;
      this.onAccountCalendarChange(AccountingCalendarEnum.P12);
      this.disableAccountingCalendar = true;
    } else {
      this.disableAccountingCalendar = false;
    }
  }

  onEngagementAddedChange(isAvailable: number) {
    this.isEngagementAvailable = isAvailable;
    this.engagement.PaceId = "";
    this.engagement.IsEngagementAvailable =
      this.isEngagementAvailable == 1 ? true : false;
    this.isEngagementChangeValid = false;
  }

  getPaceIdStyle(): any {
    if (this.engagement.ProjectCategoryId == 1) {
      return { "padding-left": "7px !important" };
    } else {
      return { "padding-left": "3px !important" };
    }
  }

  /* Commented out total cost template disabled functionality for 4/4/5 Account calendars*/

  // templateOptionChange(val: any) {
  //   //  When we select total cost template from template dropdown hiding
  //   //  445,454,544 calendars from accounting calendar dropdown
  //   if (val && val !== null) {
  //     if (val === TemplateEnum.TotalCost) {
  //       this.accountingCalendarList = this.accountingCalendarList.filter(
  //         (item) =>
  //           item.id === AccountingCalendarEnum.P12 ||
  //           item.id === AccountingCalendarEnum.P13
  //       );
  //     } else {
  //       // When we select other than total cost template showing 445,454 & 544 calendars
  //       this.accountingCalendarList = this.filterAccountingCalendarList;
  //     }
  //   } else {
  //     // When we select null value from Template dropdown showing 445,454 & 544 calendars
  //     this.accountingCalendarList = this.filterAccountingCalendarList;
  //   }
  // }

  getUserNames(_event?: any) {
    if(!this.isClearClicked){
      if(this.engagement.UserNames?.length ===0) {
      this.engagement.UserNames = this.loggedInUserData;
    }
    this.isRequired = true;
      this.isClearClicked = true;
    } 
  }
}
